import Select from 'react-select';
import { useLiveQuery } from "dexie-react-hooks";
import { db, withExtras, withParents, withFormulas } from "../../Utils/Functions/Dexie-Setup";
import { tableConfigs } from "../../Utils/Functions/Table_Configs";
import { useMemo, useCallback } from "react"


const defaultDisplay = ["recordId"];
const defaultFunc = () => (true)

//defaultValues, canCreate, 
const RelationshipInput = ({ tableName, fieldValue, setFieldValue, label, displayFields = defaultDisplay, filter = defaultFunc, disabled, ...rest }) => {

  const keyField = useMemo(() => tableConfigs[tableName].fields.find(field => field.type === "key").label, [tableName]);

  const createOptions = useCallback((records) => {
    //console.log({records})
    return records?.map(record => ({
      label: displayFields.map((curr) => record[curr]).join(" | "),
      value: record[keyField],
    }))
  }, [displayFields, keyField])

  const options = useLiveQuery(() => db[tableName].filter(filter).toArray(withExtras(tableName, [withParents, withFormulas, () => createOptions])), [tableName, filter])

  const onChange = useCallback((newValue) => setFieldValue(newValue?.value ?? null), [setFieldValue])

  return (
    // <div className="mb-5 min-w-80 flex flex-col w-80">
    <>
      <label htmlFor={`${tableName}-${label}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
      <Select
        id={`${tableName}-${label}`}
        isClearable
        onChange={onChange}
        options={options}
        value={options?.find(({ value }) => fieldValue === value) ?? null}
        isDisabled={!!disabled}
        {...rest}
      />
    </>
  )
}

export default RelationshipInput


// import CreatableSelect from 'react-select/creatable';
// import Select from 'react-select';
// import { useLiveQuery } from "dexie-react-hooks";
// import { db, createLocalRecord } from "../../Utils/Functions/Dexie-Setup";
// import { tableConfigs } from "../../Utils/Functions/Table_Configs";
// import { useState, useEffect } from "react"

// const createOption = (option, displayFields, keyField) => {
//     return {
//         label: displayFields.map((curr) => option[curr]).join(" | "),
//         value: option[keyField],
//     }
// }
// const defaultDefaultRecord = {};
// const defaultDisplay = ["recordId"];
// const defaultFunc = () => (true)

// const RelationshipInput = ({disabled, newRecordDefaultValues, canCreate, form, tableName, primaryKey, fieldName, label, relatedTable = tableConfigs[tableName].fields.find(field => field.label === fieldName).relTo, displayFields = defaultDisplay, defautltRecord = defaultDefaultRecord, filterFunc = defaultFunc, ...rest}) => {
//     // const [searchText, setSearchText] = useState("");
//     // const relatedTable = tableConfigs[tableName].fields.find(field => field.label === fieldName).relTo;
//     const relatedKey = tableConfigs[relatedTable].fields.find(field => field.type === "key").label;
//     const record = useLiveQuery(() => db[tableName].get(primaryKey), [primaryKey, tableName]);
//     const relatedRecords = useLiveQuery(() => db[relatedTable].toArray(), [relatedTable])
//     const [isLoading, setIsLoading] = useState(false);
//     const [value, setValue] = useState(null)
//     const [options, setOptions] = useState([]);
//     const [createdId, setCreatedId] = useState(null);

//     // const [isModalOpen, setIsModalOpen] = useState(false);
//     // const onCloseModal = () => {
//     //   setIsModalOpen(false);
//     // }

//     useEffect(() => {
//         const filteredRecords = relatedRecords ? relatedRecords.filter(filterFunc) : [];
//         if(!filteredRecords.length) db[tableName].update(primaryKey, {[fieldName]: null});
//         setOptions(filteredRecords ? filteredRecords.map((record) => createOption(record, displayFields, relatedKey)) : []);
//         if(createdId) {
//             const option = options.find(option => option.value === createdId);
//             if(option) {
//                 setValue(option);
//                 setIsLoading(false);
//             }
//         }
//     }, [relatedRecords, displayFields, filterFunc, relatedKey])

//     useEffect(() => {
//         if(record) {
//             const option = options.find(option => option.value === record[fieldName]);
//             setValue(option ? option : null)
//             setIsLoading(false)
//         }
//     }, [record, options, fieldName])

//     return (
//         // <div className="mb-5 min-w-80 flex flex-col w-80">
//         <>
//             <label htmlFor={`${primaryKey}-${fieldName}`} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
//             {canCreate ? <CreatableSelect
//                 id={`${primaryKey}-${fieldName}`}
//                 isClearable
//                 isDisabled={isLoading || disabled}
//                 isLoading={isLoading}
//                 onChange={(newValue) => {db[tableName].update(primaryKey, {[fieldName]: newValue ? newValue.value : null})}}
//                 onCreateOption={(option) => {setIsLoading(true); createLocalRecord(relatedTable, {[displayFields[0]]: option}).then((id) => setCreatedId(id))}}
//                 options={options}
//                 value={value}
//                 {...rest}
//                 /> :
//                 (<Select 
//                 id={`${primaryKey}-${fieldName}`}
//                 isClearable
//                 isDisabled={isLoading || disabled}
//                 isLoading={isLoading}
//                 onChange={(newValue) => db[tableName].update(primaryKey, {[fieldName]: newValue ? newValue.value : null})}
//                 options={options}
//                 value={value}
//                 {...rest}
//                 />)
//                 }
//         </>
//     )
// }

// export default RelationshipInput
